<template>
    <v-row no-gutters class="pr-8 pl-6 pt-8">
        <div
            v-if="!isAccountElite(companyId)"
            class="mb-4"
        >
            <EliteRow :company-id="companyId" />
        </div>
        <CustomFormEditor
            related-type="account_member"
            :account-id="companyId"
            :form-data="formData"
            :disabled="!canEdit"
            :show-app-store-save="isSelected"
            :external-save="true"
            @update="updateTab"
        ></CustomFormEditor>
    </v-row>
</template>

<script>
import {computed, ref} from "@vue/composition-api";
import AppStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import CustomFormEditor from '../CustomField/CustomFormEditor.vue'
import {APP_STORE_APP_TYPES} from "../../../helpers/constants";
import EliteRow from "../../../components/Elite/EliteRow.vue";
import AccountModule from "@/store/modules/account";

export default {
    name: "WorkforceManagementDialogMemberFieldsTab",
    props: {
        isSelected: {
            type: Boolean,
            default: false
        }
    },
    components: {
        EliteRow,
        CustomFormEditor
    },
    setup() {
        const {appStoreDialogState} = AppStoreDialog()
        const { isAccountElite, isFeatureEnabled } = AccountModule();

        const formData = ref({items: null, static_items: null});

        const companyId = computed(() => {
            return appStoreDialogState.appData.company_id
        });

        const canEdit = computed(() => {
            return isAccountElite(companyId.value) || isFeatureEnabled(companyId.value, APP_STORE_APP_TYPES.MEMBER_FIELDS, false)
        })

        const updateTab = () => {
        };

        return {
            companyId,
            formData,
            updateTab,
            canEdit,
            isAccountElite
        };
    }
};
</script>
